import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/admin/building",
        component: List,
        name: "building-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/building/:id/edit",
        component: Edit,
        name: "building-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/building/create",
        component: Create,
        name: "building-create",
        meta: {
            requiresAuth: true,
        },
    },
];
